import { createSlice } from "@reduxjs/toolkit";

export interface MeetingState {
    isMeetingStart: boolean,
    isResponderMeetingStart:boolean
}
const initialState: MeetingState = {
    isMeetingStart: false,
    isResponderMeetingStart:false
}

const meetingSlice = createSlice({
    name: "meeting",
    initialState,
    reducers: {
        setMeetingStarts: (state: MeetingState, action) => {
            state.isMeetingStart = action.payload;
        },
        setResponderMeetingStart: (state: MeetingState, action) => {
            state.isResponderMeetingStart = action.payload;
        }
    },

});

export const {setMeetingStarts,setResponderMeetingStart } =
    meetingSlice.actions;
export default meetingSlice.reducer;